import React from "react";
import { ASSETS } from "@/data/content";
import { Reveal } from "@/lib/reveal";

// Compact quote band. The watercolour is anchored to the bottom and rises
// above the green band so the head pokes out the top. Landscape = faint bg only.
export const LandBand = ({ bg, wc, variant = "dark", kicker, quote, author }) => {
  const dark = variant === "dark";
  const section = dark ? "bg-forest" : "bg-cream";
  const veil = dark ? "bg-forest/80" : "bg-cream/85";
  const bgOpacity = dark ? "opacity-30" : "opacity-20";
  const quoteColor = dark ? "text-cream" : "text-ink";
  const markColor = dark ? "text-ochre" : "text-terracotta";
  const kickerColor = dark ? "text-ochre" : "text-carbondark";
  const authorColor = dark ? "text-cream/85" : "text-sage";
  const rule = dark ? "bg-ochre" : "bg-terracotta";

  return (
    <section data-testid="land-band" className={`relative ${section} py-14 md:py-16`}>
      {/* faint landscape background, clipped */}
      <div className="absolute inset-0 overflow-hidden">
        <img src={ASSETS[bg]} alt="" aria-hidden className={`h-full w-full object-cover ${bgOpacity}`} />
        <div className={`absolute inset-0 ${veil}`} />
      </div>

      {/* watercolour — anchored to the band's bottom, rises above the top (desktop) */}
      <img
        src={ASSETS[wc]}
        alt=""
        className="pointer-events-none absolute bottom-0 left-[4%] z-10 hidden h-[27rem] w-auto object-contain drop-shadow-[0_18px_24px_rgba(42,32,21,0.3)] md:block lg:left-[9%]"
      />

      <div className="relative z-20 mx-auto max-w-[1400px] px-5 md:px-10">
        {/* mobile figure */}
        <img src={ASSETS[wc]} alt="" className="mx-auto mb-6 h-56 w-auto object-contain drop-shadow-[0_16px_20px_rgba(42,32,21,0.3)] md:hidden" />

        <Reveal className="text-center md:ml-[42%] md:max-w-2xl md:text-left lg:ml-[44%]">
          <span className={`font-body text-xs uppercase tracking-[0.3em] ${kickerColor}`}>{kicker}</span>
          <blockquote className={`mt-3 font-display text-2xl font-medium leading-[1.12] ${quoteColor} sm:text-3xl lg:text-4xl`}>
            <span className={markColor}>“</span>{quote}<span className={markColor}>”</span>
          </blockquote>
          <footer className="mt-4 flex items-center justify-center gap-3 md:justify-start">
            <span className={`h-px w-10 ${rule}`} />
            <span className={`font-script text-xl ${authorColor} md:text-2xl`}>{author}</span>
          </footer>
        </Reveal>
      </div>
    </section>
  );
};
